import { Link, Navigate, Outlet } from 'react-router-dom'
import ECommerceHeader from '@/components/layout/ECommerceHeader'
import Footer from '@/components/layout/Footer'
import { useAuthStore } from '@/stores/auth'
import { User, MapPin, CreditCard, Bell, LogOut, Package } from 'lucide-react'

export default function AccountLayout() {
  const { isAuthenticated, logout } = useAuthStore()

  if (!isAuthenticated) {
    return <Navigate to="/login" />
  }

  return (
    <div className="min-h-screen bg-background">
      <ECommerceHeader />

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-3xl font-bold text-foreground mb-8">My Account</h1>

          <div className="grid lg:grid-cols-12 gap-6">
            {/* Sidebar */}
            <div className="lg:col-span-3">
              <div className="bg-card rounded-lg border border-border p-4 sticky top-4">
                <nav className="space-y-2">
                  <Link
                    to="/account"
                    className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-muted-foreground hover:bg-muted transition-colors"
                  >
                    <User className="h-5 w-5" />
                    Profile
                  </Link>
                  <Link
                    to="/account/addresses"
                    className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-muted-foreground hover:bg-muted transition-colors"
                  >
                    <MapPin className="h-5 w-5" />
                    Addresses
                  </Link>
                  <Link
                    to="/account/payment-methods"
                    className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-muted-foreground hover:bg-muted transition-colors"
                  >
                    <CreditCard className="h-5 w-5" />
                    Payment Methods
                  </Link>
                  <Link
                    to="/account/notifications"
                    className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-muted-foreground hover:bg-muted transition-colors"
                  >
                    <Bell className="h-5 w-5" />
                    Notifications
                  </Link>
                  <Link
                    to="/orders"
                    className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-muted-foreground hover:bg-muted transition-colors"
                  >
                    <Package className="h-5 w-5" />
                    Orders
                  </Link>
                  <button
                    onClick={logout}
                    className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-destructive hover:bg-destructive/10 transition-colors"
                  >
                    <LogOut className="h-5 w-5" />
                    Logout
                  </button>
                </nav>
              </div>
            </div>

            {/* Main Content - Outlet for nested routes */}
            <div className="lg:col-span-9">
              <Outlet />
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}
